import React from 'react'

export default function EmailIcon (props) {
  return (
    <svg x='0px' y='0px' width='16px' height='16px' viewBox='0 0 16 16'>
      <g>
        <path fill='currentColor' d='M15,1H1C0.448,1,0,1.447,0,2v12c0,0.553,0.448,1,1,1h14c0.552,0,1-0.447,1-1V2C16,1.447,15.552,1,15,1z
     M14,13H2V6.723l5.504,3.145c0.308,0.176,0.685,0.176,0.992,0L14,6.723V13z M14,4.42L8,7.849L2,4.42V3h12V4.42z' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/email.js